export class EmailAttachmentService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async insertAttachment(emailAttachment) {
        const response = await this.apiService.post('emailAttachment', emailAttachment.getState());
        if (response.status === 200) {
            return true;
        }
    }
}
